/**
 * Formats a date string to a localized format (e.g., "23 May 25")
 * @param dateString - ISO date string (e.g., "2025-05-23")
 * @returns Formatted date string in en-GB format
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "2-digit",
  });
};

/**
 * Gets tomorrow's date in ISO format (YYYY-MM-DD)
 * @returns ISO date string for tomorrow
 */
export const getTomorrowDate = (): string => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toISOString().split("T")[0];
};
